import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = {
  id: "drivers-list-container",
  class: "kn-flex kn-relative"
}
const _hoisted_4 = {
  id: "driver-details-container",
  class: "kn-flex kn-relative"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_InlineMessage = _resolveComponent("InlineMessage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.history.listTitle')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.add'),
            class: "p-button-text p-button-rounded p-button-plain kn-white-color",
            onClick: _ctx.setUploadType
          }, null, 8, ["label", "onClick"]),
          (!_ctx.uploading)
            ? (_openBlock(), _createBlock(_component_KnInputFile, {
                key: 0,
                label: "",
                changeFunction: _ctx.startTemplateUpload,
                triggerInput: _ctx.triggerUpload
              }, null, 8, ["changeFunction", "triggerInput"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                class: "kn-progress-bar",
                mode: "indeterminate",
                "data-test": "progress-bar"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_KnListBox, {
                key: 1,
                class: "kn-height-full",
                options: _ctx.listOfTemplates,
                settings: _ctx.historyDescriptor.knListSettings,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTemplate($event.item))),
                onSetActive: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setActiveTemplate($event.item)), ["stop"])),
                onDownload: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadTemplate($event.item)), ["stop"])),
                onDelete: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.deleteTemplateConfirm($event.item)), ["stop"]))
              }, null, 8, ["options", "settings"]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    _createVNode("div", {
      class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0",
      style: _ctx.mainDescriptor.style.driverDetailsContainer
    }, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.history.template')), 1)
        ]),
        end: _withCtx(() => [
          (_ctx.designerButtonVisible)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: _ctx.$t('documentExecution.olap.openDesigner'),
                class: "p-button-text p-button-rounded p-button-plain kn-white-color",
                onClick: _ctx.openDesignerConfirm
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          (_ctx.showTemplateContent)
            ? (_openBlock(), _createBlock(_component_VCodeMirror, {
                key: 0,
                ref: "codeMirrorScriptType",
                class: "kn-height-full",
                value: _ctx.selectedTemplateContent,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTemplateContent = $event)),
                options: _ctx.scriptOptions,
                onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["value", "options"]))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_InlineMessage, {
                  severity: "info",
                  class: "p-m-2 kn-width-full"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.history.templateHint')), 1)
                  ]),
                  _: 1
                })
              ]))
        ], 4)
      ])
    ], 4)
  ]))
}